import { Box, Tooltip, TypographyVariant } from '@mui/material';
import { round } from 'lodash';

import { Typography } from '@occc-app/design-system';
import { separateEveryThousandByComma } from '@occc-app/lib/numbers';

type RetailerNetworkPerformanceInfoItemProps = {
  performanceTitle: string;
  performanceValueTooltipTitle: number;
  performanceValue: string | number;
  avgTitle: string;
  avgValue: string | number;
  performanceValueTypographyVariant?: TypographyVariant;
};

export const RetailerNetworkPerformanceInfoItem = ({
  performanceTitle,
  performanceValue,
  performanceValueTypographyVariant = 'h4',
  performanceValueTooltipTitle,
  avgTitle,
  avgValue,
}: RetailerNetworkPerformanceInfoItemProps) => (
  <>
    <Box sx={{ mb: 1.5 }}>
      <Typography color='textSecondary' variant='body2'>
        {performanceTitle}
      </Typography>
      <Tooltip
        title={separateEveryThousandByComma(round(performanceValueTooltipTitle, 2))}
        placement='top'
        disableHoverListener={!performanceValueTooltipTitle}
        arrow
        followCursor
      >
        <Typography variant={performanceValueTypographyVariant} component='span'>
          {performanceValue}
        </Typography>
      </Tooltip>
    </Box>
    <Box>
      <Typography color='textSecondary' variant='body2'>
        {avgTitle}
      </Typography>
      <Typography color='textSecondary' variant='h6'>
        {avgValue}
      </Typography>
    </Box>
  </>
);
